import React from "react";
import { Badge } from "@/components/ui/badge";
import type { ProposalStatus } from "@/types/proposal";

export const PROPOSAL_STATUS_LABELS: Record<ProposalStatus, string> = {
  DRAFT: "Draft",
  IN_REVIEW: "In Review",
  APPROVED: "Approved",
  SENT: "Sent",
  VIEWED: "Viewed",
  ACCEPTED: "Accepted",
  DECLINED: "Declined",
  EXPIRED: "Expired",
  SUPERSEDED: "Superseded",
};

const VARIANTS: Record<ProposalStatus, "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue"> = {
  DRAFT: "secondary",
  IN_REVIEW: "warning",
  APPROVED: "blue",
  SENT: "default",
  VIEWED: "default",
  ACCEPTED: "success",
  DECLINED: "destructive",
  EXPIRED: "destructive",
  SUPERSEDED: "outline",
};

export function ProposalStatusBadge({ status }: { status: ProposalStatus }) {
  return <Badge variant={VARIANTS[status] || "outline"}>{PROPOSAL_STATUS_LABELS[status] || status}</Badge>;
}
